/**
 * GDJ fulfillment guard — a cart can't mix in-store-pickup-only products
 * (Prextra shippable=0 -> hub.pickup_only) with deliverable products.
 *
 * Pickup-only cart lines carry the visible line-item property
 * "SHIPPING NOT AVAILABLE" = "PICKUP ONLY" (set by buy-buttons / quick-add),
 * which doubles as the reliable cart-side marker here. When adding an item
 * would create a mixed cart we show one confirm dialog (warning + the relevant
 * message); on Continue we remove the other fulfilment type, then add.
 *
 * Exposes window.gdjFulfillment for the custom quick-add path; the PDP + sticky
 * bar are handled by the capture-phase click intercept at the bottom (same
 * approach as gdj-assortment-prompt).
 */
(function () {
  var S = window.gdjFulfillmentStrings || {};
  var PROP = 'SHIPPING NOT AVAILABLE';
  var root = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  // ── cart composition cache ───────────────────────────────────────────────
  var hasPickup = false,
    hasShippable = false,
    ready = false;

  function recompute(cart) {
    hasPickup = false;
    hasShippable = false;
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties[PROP] != null) hasPickup = true;
      else hasShippable = true;
    });
    ready = true;
  }
  function refresh() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(recompute)
      .catch(function () {});
  }
  refresh();
  document.addEventListener('shopify:cart:lines-update', function () { setTimeout(refresh, 200); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  // ── modal ─────────────────────────────────────────────────────────────────
  var dlg = document.querySelector('[data-gdj-fguard]');
  var bodyEl = dlg && dlg.querySelector('[data-gdj-fguard-body]');
  var settle = null;

  function closeModal(val) {
    if (dlg && dlg.open) dlg.close();
    if (settle) { var s = settle; settle = null; s(val); }
  }
  if (dlg) {
    var cancelBtn = dlg.querySelector('[data-gdj-fguard-cancel]');
    var confirmBtn = dlg.querySelector('[data-gdj-fguard-confirm]');
    if (cancelBtn) cancelBtn.addEventListener('click', function () { closeModal(false); });
    if (confirmBtn) confirmBtn.addEventListener('click', function () { closeModal(true); });
    dlg.addEventListener('cancel', function () { if (settle) { var s = settle; settle = null; s(false); } });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeModal(false); });
  }

  function bodyFor(kind) {
    return (kind === 'add-pickup' ? S.body_add_pickup : S.body_add_shippable) || '';
  }
  function confirmKind(kind) {
    return new Promise(function (resolve) {
      if (!dlg || typeof dlg.showModal !== 'function') {
        resolve(window.confirm(bodyFor(kind)));
        return;
      }
      settle = resolve;
      if (bodyEl) bodyEl.textContent = bodyFor(kind);
      dlg.showModal();
    });
  }

  // ── conflict detection + resolution ────────────────────────────────────────
  function conflictFor(addingPickup) {
    if (!ready) return null; // cart state unknown → don't block (cart + checkout still warn)
    if (addingPickup && hasShippable) return 'add-pickup';
    if (!addingPickup && hasPickup) return 'add-shippable';
    return null;
  }

  function clearConflicting(kind) {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (it) {
          var isPickup = it.properties && it.properties[PROP] != null;
          var remove = kind === 'add-pickup' ? !isPickup : !!isPickup;
          if (remove) updates[it.key] = 0;
        });
        if (!Object.keys(updates).length) return;
        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () { return refresh(); });
      });
  }

  window.gdjFulfillment = {
    refresh: refresh,
    conflictFor: conflictFor,
    confirm: confirmKind,
    clearConflicting: clearConflicting,
    cartHasPickup: function () { return hasPickup; },
    cartHasShippable: function () { return hasShippable; },
    PROP: PROP,
  };

  // ── PDP + sticky bar: capture-phase click intercept ─────────────────────────
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(
        'product-form-component button[name="add"], form[action*="/cart/add"] button[name="add"]'
      );
      if (!btn) return;
      if (btn.dataset.gdjFulfillOk) { delete btn.dataset.gdjFulfillOk; return; }
      var form = btn.closest('form');
      var addingPickup = !!(form && form.querySelector('input[name="properties[' + PROP + ']"]'));
      var kind = conflictFor(addingPickup);
      if (!kind) return; // no conflict → let Horizon handle normally
      e.preventDefault();
      e.stopImmediatePropagation();
      confirmKind(kind).then(function (ok) {
        if (!ok) return; // cancel → nothing added
        clearConflicting(kind).then(function () {
          btn.dataset.gdjFulfillOk = '1';
          btn.click();
        });
      });
    },
    true
  );
})();
